import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  @Output() sendModalData = new EventEmitter<any>();

  constructor() { }

  openModal(title: string, content: string){
    this.sendModalData.next({title: title, content: content});
  }
}
